<script setup lang="ts">
import {
  BaseIcon,
  FieldAvatarUploader,
  FieldPhoneNumber,
} from '@magma-app/magma-lapilli';

const props = defineProps<{
  formData: {
    profilePicture: File | null;
    phoneNumber: string;
  };
  validation: any;
  locale: string;
  previewUrl?: string;
}>();

const emit = defineEmits<{
  (event: 'phone-change'): void;
  (event: 'picture-change', file: File): void;
}>();

const onPhoneChange = () => {
  emit('phone-change');
};

const onPictureChange = (file: File) => {
  emit('picture-change', file);
};
</script>

<template>
  <div>
    <div class="mt-8 flex items-center">
      <BaseIcon icon="check" color="#03874C" bg-color="#ECFDF3" />

      <h2 class="ml-4 text-mgm-txt-md font-medium text-foreground-emphasis">
        {{ $t('helperCampaignSignUpView.completeProfile') }}
      </h2>
    </div>

    <p class="mt-2 text-mgm-txt-sm font-normal text-foreground-default">
      {{ $t('helperCampaignSignUpView.completeProfileDescription') }}
    </p>

    <FieldAvatarUploader
      id="profilePicture"
      v-model="formData.profilePicture"
      class="mt-4"
      :cta="$t('generic.change')"
      :label="$t('generic.profilePicture')"
      :locale="locale"
      :preview-url="previewUrl"
      :validation="validation.profilePicture"
      data-cy="profile-pic"
      @change="onPictureChange"
    />

    <FieldPhoneNumber
      id="phone"
      v-model="formData.phoneNumber"
      data-cy="phone"
      class="mt-4"
      :locale="locale"
      :label="$t('generic.phoneNumber')"
      :validation="validation.phoneNumber"
      @change="onPhoneChange"
    />
  </div>
</template>
